import { render, staticRenderFns } from "./DataAutocomplete.vue?vue&type=template&id=909cf47e"
import script from "./DataAutocomplete.vue?vue&type=script&lang=js"
export * from "./DataAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports